import React, { useState } from "react";
import Index from "../../business/Index";
import PagesIndex from "../../business/PagesIndex";

const GetInContact = () => {
  const [loading, setLoading] = useState(false);
  const submitForm = async (value) => {
    let formData = {
      businessName: value.businessName,
      businessOwnerName: value.businessOwnerName,
      email: value.email,
      phoneNumber: value.phoneNumber,
      message: value.message,
    };
    try {
      setLoading(true);
      const res = await PagesIndex.DataService.post(
        PagesIndex.Api.Common.Send_BecomePartner,
        formData
      );
      if (res.status === 200) {
        PagesIndex.toast.success(res.data.message);
      }
    } catch (error) {
      PagesIndex.toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Index.Box className="get-in-contact-main">
        <Index.Box className="container-user">
          <Index.Box className="get-in-contact">
            <Index.Box className="get-in-contact-content">
              <Index.Box className="get-in-welcome-content">
                <span></span>
                <Index.Typography
                  component="h6"
                  className="get-in-ugoout-title"
                >
                  Get in contact
                </Index.Typography>
              </Index.Box>
              <Index.Typography className="get-in-description">
                Get in contact
              </Index.Typography>
            </Index.Box>

            <Index.Box className="contact-grid">
              <Index.Box className="cols1-grid">
                <Index.Box className="contact-details">
                  <Index.Box className="contact-text-details">
                    <Index.Typography className="contact-title">
                      Send us a message
                    </Index.Typography>
                    <Index.Typography className="contact-description">
                      To get more information on how we can help please feel
                      free to reach out and a member of our team will be in
                      contact.
                    </Index.Typography>
                  </Index.Box>
                  <PagesIndex.Formik
                    validationSchema={PagesIndex.GetInContactSchema}
                    initialValues={{
                      businessName: "",
                      businessOwnerName: "",
                      email: "",
                      phoneNumber: "",
                      message: "",
                    }}
                    onSubmit={submitForm}
                  >
                    {({
                      values,
                      errors,
                      handleChange,
                      handleBlur,
                      touched,
                      handleSubmit,
                      setFieldValue,
                    }) => (
                      <PagesIndex.Form onSubmit={handleSubmit}>
                        {console.log("error", errors)}
                        <Index.Box className="contact-form-details">
                          <Index.Grid container columnSpacing={2}>
                            <Index.Grid item xs={12} md={6} lg={6}>
                              <Index.Box className="contact-form-group">
                                <Index.Typography className="form-user-label">
                                  Business Name
                                </Index.Typography>
                                <Index.TextField
                                  name="businessName"
                                  value={values.businessName}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  variant="standard"
                                  className="form-control-user"
                                  inputProps={{ maxLength: 30 }}
                                  InputLabelProps={{
                                    shrink: !!values.businessName,
                                  }}
                                />
                                {errors.businessName && touched.businessName ? (
                                  <Index.Typography className="error-msg">
                                    {errors.businessName}
                                  </Index.Typography>
                                ) : null}
                              </Index.Box>
                            </Index.Grid>

                            <Index.Grid item xs={12} md={6} lg={6}>
                              <Index.Box className="contact-form-group">
                                <Index.Typography className="form-user-label">
                                  Business Owners Name
                                </Index.Typography>
                                <Index.TextField
                                  name="businessOwnerName"
                                  value={values.businessOwnerName}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  variant="standard"
                                  className="form-control-user"
                                  inputProps={{ maxLength: 30 }}
                                  InputLabelProps={{
                                    shrink: !!values.businessOwnerName,
                                  }}
                                />
                                {errors.businessOwnerName &&
                                touched.businessOwnerName ? (
                                  <Index.Typography className="error-msg">
                                    {errors.businessOwnerName}
                                  </Index.Typography>
                                ) : null}
                              </Index.Box>
                            </Index.Grid>

                            <Index.Grid item xs={12} md={6} lg={6}>
                              <Index.Box className="contact-form-group">
                                <Index.Typography className="form-user-label">
                                  Email
                                </Index.Typography>
                                <Index.TextField
                                  name="email"
                                  value={values.email}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  variant="standard"
                                  className="form-control-user"
                                  inputProps={{ maxLength: 50 }}
                                  InputLabelProps={{ shrink: !!values.email }}
                                />
                                {errors.email && touched.email ? (
                                  <Index.Typography className="error-msg">
                                    {errors.email}
                                  </Index.Typography>
                                ) : null}
                              </Index.Box>
                            </Index.Grid>

                            <Index.Grid item xs={12} md={6} lg={6}>
                              <Index.Box className="contact-form-group">
                                <Index.Typography className="form-user-label">
                                  Phone
                                </Index.Typography>
                                <Index.TextField
                                  name="phoneNumber"
                                  value={values.phoneNumber}
                                  onChange={(event) => {
                                    let value = event.target.value.replace(
                                      /[^\d]/g,
                                      ""
                                    ); // keep digits and '+'
                                    setFieldValue("phoneNumber", value);
                                  }}
                                  onBlur={handleBlur}
                                  variant="standard"
                                  className="form-control-user"
                                  inputProps={{ maxLength: 10 }}
                                  InputLabelProps={{
                                    shrink: !!values.phoneNumber,
                                  }}
                                />
                                {errors.phoneNumber && touched.phoneNumber ? (
                                  <Index.Typography className="error-msg">
                                    {errors.phoneNumber}
                                  </Index.Typography>
                                ) : null}
                              </Index.Box>
                            </Index.Grid>

                            <Index.Grid item xs={12} lg={12}>
                              <Index.Box className="contact-form-group">
                                <Index.Typography className="form-user-label">
                                  Message
                                </Index.Typography>
                                <Index.TextField
                                  name="message"
                                  value={values.message}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  variant="standard"
                                  className="form-control-user"
                                  multiline
                                  inputProps={{ maxLength: 250 }}
                                  InputLabelProps={{ shrink: !!values.message }}
                                />
                                {errors.message && touched.message ? (
                                  <Index.Typography className="error-msg">
                                    {errors.message}
                                  </Index.Typography>
                                ) : null}
                              </Index.Box>
                            </Index.Grid>

                            <Index.Grid item xs={12} lg={12}>
                              <Index.Box className="header-btn-login get-contact-btn">
                                <Index.Button
                                  className="login-btn-user"
                                  disabled={loading}
                                  type="submit"
                                >
                                  {loading ? "Sending..." : "Send message"}
                                </Index.Button>
                              </Index.Box>
                            </Index.Grid>
                          </Index.Grid>
                        </Index.Box>
                      </PagesIndex.Form>
                    )}
                  </PagesIndex.Formik>
                </Index.Box>
              </Index.Box>

              <Index.Box className="cols2-grid">
                <Index.Box className="contact-image">
                  <img src={PagesIndex.Png.getContact} alt="get-contact-img" />
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>
    </>
  );
};

export default GetInContact;
